import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-close-btn__circle"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-close-btn _flexcntr _ai-c _cur-p _pos-r",
    onClick: _cache[0] || (_cache[0] = (...args) => ($options.onClose && $options.onClose(...args))),
    "data-qa": $props.qa
  }, [
    _createVNode(_component_base_icon, {
      name: "times",
      class: "gfu-close-btn__icon _fa--tac _fa--fw-eb _fa--lighter"
    }),
    ($props.duration)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          _createElementVNode("circle", {
            ref: "circle",
            style: _normalizeStyle(_ctx.circleStyles),
            cx: "10",
            cy: "10",
            r: "10"
          }, null, 4 /* STYLE */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}